import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Fleet } from "./components/Fleet";
import { Destinations } from "./components/Destinations";
import { Manifesto } from "./components/Manifesto";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Admin } from "./pages/Admin";

function Home() {
  const [preselectedVessel, setPreselectedVessel] = useState("");
  const [preselectedDestination, setPreselectedDestination] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const handleEnquire = (vesselName) => {
    setPreselectedVessel(vesselName);
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  const handlePlanDestination = (destinationName) => {
    setPreselectedDestination(destinationName);
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="grain-overlay bg-abyss min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Fleet onEnquire={handleEnquire} />
        <Destinations onPlan={handlePlanDestination} />
        <Manifesto />
        <Contact preselectedVessel={preselectedVessel} preselectedDestination={preselectedDestination} />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0B1528",
              border: "1px solid rgba(212,175,55,0.35)",
              color: "#F7F5F0",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
            },
          }}
        />
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
